<section id="productos" class="section">
	<div class="container">
		<h2>Productos de la suite NETiC</h2>
		<p class="section-lead">
			Cada producto responde a una necesidad de gestión específica, manteniendo una base funcional común y una
			experiencia de uso consistente.
		</p>
		<div class="card-grid four-cols">
			<article class="card">
				<h3>GESTIÓN MULTIRUBRO</h3>
				<p>Ideal para negocios con procesos mixtos que necesitan una operación flexible y centralizada.</p>
			</article>
			<article class="card">
				<h3>GESTIÓN SERVICIO TÉCNICO</h3>
				<p>Orientado a diagnóstico, seguimiento técnico y control de equipos con foco en trazabilidad.</p>
			</article>
			<article class="card">
				<h3>GESTIÓN TALLER</h3>
				<p>Pensado para operaciones de taller con control de órdenes, tiempos, tareas y estado de trabajo.</p>
			</article>
			<article class="card">
				<h3>GESTIÓN SOCIOS</h3>
				<p>Producto más diferencial: agrega gestión de socios, cuotas, vencimientos y estados de cuenta.</p>
			</article>
		</div>
	</div>
</section>